// extracted by mini-css-extract-plugin
module.exports = {"jobPosition":"jobposition_jobPosition__s2c84","offerTitle":"jobposition_offerTitle__LH2Z6","headline":"jobposition_headline__11rHP"};